<template>
  <div class="tw-size-full tw-relative tw-max-w-full tw-max-h-full">
    <iframe
      :src="link"
      frameborder="0"
      class="tw-absolute tw-top-0 tw-left-0 tw-size-full tw-outline-none tw-border-none focus:tw-outline-none"
    />
  </div>
</template>

<script>
export default {
  props: {
    link: {
      type: String,
      default: '',
    },
  },
}
</script>
